import { render } from "./ApprovedQuoteDetail.vue?vue&type=template&id=1dcffb44&scoped=true"
import script from "./ApprovedQuoteDetail.vue?vue&type=script&lang=js"
export * from "./ApprovedQuoteDetail.vue?vue&type=script&lang=js"

import "./ApprovedQuoteDetail.vue?vue&type=style&index=0&id=1dcffb44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcffb44"]])

export default __exports__